// Note: NODE_ENV does not represent which environment we are running the code in.
// Setting NODE_ENV=production enables caching of templates, css and less verbose error messages.
const environment = process.env.REACT_APP_SIGNUP_ENVIRONMENT || 'development';
const apiUrl = process.env.REACT_APP_SIGNUP_API_BASE_URL;
const REACT_APP_SIGNUP_FIND_CITY_END_POINT =
    process.env.REACT_APP_SIGNUP_FIND_CITY_END_POINT;
const REACT_APP_SIGNUP_GIVELIFY_DONOR_SIGNUP_PAGE_URL =
    process.env.REACT_APP_SIGNUP_GIVELIFY_DONOR_SIGNUP_PAGE_URL;
const REACT_APP_SIGNUP_GIVELIFY_SIGN_IN_PAGE_URL =
    process.env.REACT_APP_SIGNUP_GIVELIFY_SIGN_IN_PAGE_URL;
const REACT_APP_SIGNUP_GIVELIFY_HOME_PAGE_URL =
    process.env.REACT_APP_SIGNUP_GIVELIFY_HOME_PAGE_URL;
const REACT_APP_SIGNUP_ORGANIZATIONS_SEARCH_URL =
    process.env.REACT_APP_SIGNUP_ORGANIZATIONS_SEARCH_URL;
const REACT_APP_SIGNUP_MAXIMUM_ORGANIZATION_RESULT =
    process.env.REACT_APP_SIGNUP_MAXIMUM_ORGANIZATION_RESULT;
const REACT_APP_SIGNUP_GIVELIFY_SUPPORT_PAGE_URL =
    process.env.REACT_APP_SIGNUP_GIVELIFY_SUPPORT_PAGE_URL;
const REACT_APP_SIGNUP_DONEE_PORTAL_API_URL =
    process.env.REACT_APP_SIGNUP_DONEE_PORTAL_API_URL;
const REACT_APP_SIGNUP_MIXPANEL_TOKEN =
    process.env.REACT_APP_SIGNUP_MIXPANEL_TOKEN;
const REACT_APP_SIGNUP_NEW_ORGANIZATIONS_SEARCH_URL =
    process.env.REACT_APP_SIGNUP_NEW_ORGANIZATIONS_SEARCH_URL;
const REACT_APP_SIGNUP_WEBSOCKET_TOKEN =
    process.env.REACT_APP_SIGNUP_WEBSOCKET_TOKEN;
const REACT_APP_SIGNUP_FULLSTORY_ORG_ID =
    process.env.REACT_APP_SIGNUP_FULLSTORY_ORG_ID;

const maxOrganizationResult = Number(
    REACT_APP_SIGNUP_MAXIMUM_ORGANIZATION_RESULT,
);
if (!environment) throw new Error('REACT_APP_SIGNUP_ENVIRONMENT is not set');
if (!REACT_APP_SIGNUP_FIND_CITY_END_POINT)
    throw new Error('REACT_APP_SIGNUP_FIND_CITY_END_POINT is not set');
if (!REACT_APP_SIGNUP_GIVELIFY_DONOR_SIGNUP_PAGE_URL)
    throw new Error(
        'REACT_APP_SIGNUP_GIVELIFY_DONOR_SIGNUP_PAGE_URL is not set',
    );
if (!REACT_APP_SIGNUP_GIVELIFY_SIGN_IN_PAGE_URL)
    throw new Error('REACT_APP_SIGNUP_GIVELIFY_SIGN_IN_PAGE_URL is not set');
if (!REACT_APP_SIGNUP_GIVELIFY_HOME_PAGE_URL)
    throw new Error('REACT_APP_SIGNUP_GIVELIFY_HOME_PAGE_URL is not set');
if (!REACT_APP_SIGNUP_ORGANIZATIONS_SEARCH_URL)
    throw new Error('REACT_APP_SIGNUP_ORGANIZATIONS_SEARCH_URL is not set');
if (!REACT_APP_SIGNUP_NEW_ORGANIZATIONS_SEARCH_URL)
    throw new Error('REACT_APP_SIGNUP_NEW_ORGANIZATIONS_SEARCH_URL is not set');
if (!REACT_APP_SIGNUP_MIXPANEL_TOKEN)
    throw new Error('REACT_APP_SIGNUP_MIXPANEL_TOKEN is not set');
if (!apiUrl) throw new Error('REACT_APP_SIGNUP_API_BASE_URL is not set');
if (!maxOrganizationResult)
    throw new Error('REACT_APP_SIGNUP_MAXIMUM_ORGANIZATION_RESULT is not set');
if (!REACT_APP_SIGNUP_GIVELIFY_SUPPORT_PAGE_URL)
    throw new Error('REACT_APP_SIGNUP_GIVELIFY_SUPPORT_PAGE_URL is not set');
if (!REACT_APP_SIGNUP_DONEE_PORTAL_API_URL)
    throw new Error('REACT_APP_SIGNUP_DONEE_PORTAL_API_URL is not set');
if (!REACT_APP_SIGNUP_WEBSOCKET_TOKEN)
    throw new Error('REACT_APP_SIGNUP_WEBSOCKET_TOKEN is not set');
if (!REACT_APP_SIGNUP_FULLSTORY_ORG_ID)
    throw new Error('REACT_APP_SIGNUP_FULLSTORY_ORG_ID is not set');

export const webConfig = {
    environment,
    isDev: environment === 'development',
    isProd: environment === 'production',
    apiUrl,
    baseUrl: new URL('/api/', apiUrl).href,
    sentryUrl: process.env.REACT_APP_SIGNUP_SENTRY_URL,
    organizationSearchUrl: REACT_APP_SIGNUP_ORGANIZATIONS_SEARCH_URL,
    newOrganizationSearchUrl:
        REACT_APP_SIGNUP_NEW_ORGANIZATIONS_SEARCH_URL +
        `/?token=${REACT_APP_SIGNUP_WEBSOCKET_TOKEN}`,
    maxOrganizationResult,
    mixpanelToken: REACT_APP_SIGNUP_MIXPANEL_TOKEN,
    findCityEndPoint: REACT_APP_SIGNUP_FIND_CITY_END_POINT,
    givelifyDonorSignupPageUrl: REACT_APP_SIGNUP_GIVELIFY_DONOR_SIGNUP_PAGE_URL,
    givelifySignInPageUrl: REACT_APP_SIGNUP_GIVELIFY_SIGN_IN_PAGE_URL,
    givelifyHomePageUrl: REACT_APP_SIGNUP_GIVELIFY_HOME_PAGE_URL,
    givelifySupportUrl: REACT_APP_SIGNUP_GIVELIFY_SUPPORT_PAGE_URL,
    givelifyTermsLink: 'https://www.givelify.com/about/terms-of-use/',
    givelifyDonorsUrl: 'https://www.givelify.com/donors/',
    doneePortalApiUrl: REACT_APP_SIGNUP_DONEE_PORTAL_API_URL,
    supportFormURL: 'https://support.givelify.com/hc/en-us/requests/new',
    fullStoryOrgId: REACT_APP_SIGNUP_FULLSTORY_ORG_ID,
};
